import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { Spacer } from '../../index';

const FONT_WEIGHTS = {
    BOLD: 'bold',
    NORMAL: 'normal'
};

const FONT_STYLES = {
    ITALIC: 'italic',
    NORMAL: 'normal'
};

const TEXT_DECORATIONS = {
    UNDERLINE: 'underline'
};

const TEXT_ALIGNS = {
    LEFT: 'left',
    RIGHT: 'right',
    CENTER: 'center'
};

const TEXT_TRANSFORMS = {
    CAPITALIZE: 'capitalize',
    LOWERCASE: 'lowercase',
    UPPERCASE: 'uppercase'
};

/** Text component with predefined CSS styles. Can use all `Spacer` component options. */
const Text = props => {
    const {
        align,
        className,
        decoration,
        fontStyle,
        size,
        transform,
        weight,
        ...otherProps
    } = props;
    const textClasses = cx(
        size && `font__size--${size}`,
        decoration && `text__dec--${decoration}`,
        weight && `font__weight--${weight}`,
        fontStyle && `font__style--${fontStyle}`,
        align && `text__align--${align}`,
        transform && `text__trans--${transform}`,
        className
    );
    return (
        <Spacer
            as="span"
            className={textClasses}
            {...otherProps}
        />
    );
};

Text.displayName = 'Text';

Text.propTypes = {
    /** Sets the `text-align` CSS property */
    align: PropTypes.oneOf(Object.values(TEXT_ALIGNS)),
    className: PropTypes.string,
    /** Sets the `text-decoration` CSS property */
    decoration: PropTypes.oneOf(Object.values(TEXT_DECORATIONS)),
    /** Sets the `font-style` CSS property */
    fontStyle: PropTypes.oneOf(Object.values(FONT_STYLES)),
    /** Sets the `font-size` CSS property in pixels */
    size: PropTypes.number,
    /** Sets the `text-transform` CSS property */
    transform: PropTypes.oneOf(Object.values(TEXT_TRANSFORMS)),
    /** Sets the `font-weight` CSS property */
    weight: PropTypes.oneOf(Object.values(FONT_WEIGHTS))
};

Text.defaultProps = {
    size: 16
};

export default Text;
